var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"myFont"},[_c('SideNav'),_c('v-main',{staticStyle:{"padding-top":"0px"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }